module.exports = __webpack_public_path__ + "static/media/403.a6a0b868.svg";